<template lang="pug" src="./confirmAccount.pug"> </template>
<style lang="scss" src="./confirmAccount.scss" scoped> </style>

<script>
import { mapState } from 'vuex'
import router from '@/router'

export default {
    computed: {
        ...mapState({
            isAccountConfirmed: (state) => state.app.isAccountConfirmed
        })
    },
    created: function() {
        this.redirect()
    },
    methods: {
        redirect() {
            if (this.isAccountConfirmed) {
                setTimeout(_ => {
                    router.push('/login')
                }, 2000)
            }
        }
    }
}
</script>
